var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocumentThin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.01703 16L11.9931 16C13.4833 16 14.2379 15.2263 14.2379 13.717L14.2379 6.81074C14.2379 5.93193 14.1328 5.5403 13.5884 4.97671L9.31852 0.659098C8.80271 0.124167 8.37285 5.77878e-07 7.58957 5.09401e-07L4.01703 1.9708e-07C2.52688 6.68072e-08 1.7627 0.76417 1.7627 2.27343L1.76269 13.717C1.76269 15.2358 2.51731 16 4.01703 16ZM4.06478 14.9301C3.25284 14.9301 2.82298 14.5003 2.82298 13.6979L2.82299 2.29253C2.82299 1.50925 3.25284 1.0603 4.07433 1.0603L7.48449 1.0603L7.48449 5.48298C7.48449 6.3809 7.94299 6.8203 8.81225 6.8203L13.1776 6.8203L13.1776 13.6979C13.1776 14.5003 12.7573 14.9301 11.9358 14.9301L4.06478 14.9301ZM8.93642 5.81731C8.61165 5.81731 8.48747 5.69312 8.48747 5.36836L8.48747 1.27044L12.9675 5.81731L8.93642 5.81731Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentThin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DocumentThin.16b9a8de2b1ffec5475c5db0ff180cd5.svg";